module.exports = "/_next/static/images/warning-04fc281645806810e11619d6978a907b.svg";